import { createReducer } from 'redux-create-reducer'
import {
  ACTIVE_NONE,
  AMENITY_CHANGE,
  FILTER_CLEAR,
  FILTER_APPLY,
  FILTER_CHANGE,
  FILTER_BACKUP,
  HOTEL_TYPE_CHANGE,
  PRICE_CHANGE,
  SORT_CHANGE,
  ROOM_REMOVE,
  CHANGE_MULTIPLE,
  CODE_CHANGE,
} from '../constants'

const initialState = {
  dates: null,
  rooms: null,
  more: {
    priceRange: null,
    amenities: null,
    hotelType: null,
  },
  sort: null,
  datesApply: false,
  roomsApply: false,
  moreApply: false,
  sortApply: false,
  activeFilter: ACTIVE_NONE,
  removedRooms: '',
  isMultipleBooking: false,
}


export default createReducer(initialState, {
  [ROOM_REMOVE](state, { value }) {
    return {
      ...state,
      removedRooms: value,
    }
  },
  [FILTER_CHANGE](state, { filterType, values, additionalValues }) {
    return {
      ...state,
      [filterType]: values,
      additionalValues: typeof additionalValues === 'function' ? additionalValues(state.additionalValues) : additionalValues,
    }
  },
  [FILTER_BACKUP](state, { filterType }) {
    return {
      ...state,
      [filterType + 'Backup']: state[filterType]
    }
  },
  [SORT_CHANGE](state, { value }) {
    return {
      ...state,
      sort: value,
    }
  },
  [PRICE_CHANGE](state, { value }) {
    const [min, max] = value || []
    return {
      ...state,
      more: {
        ...state.more,
        priceRange: {
          ...state.more.priceRange,
          min: min ? parseFloat(min) : min,
          max: max ? parseFloat(max) : max,
        },
      },
    }
  },
  [AMENITY_CHANGE](state, { id, value }) {
    return {
      ...state,
      more: {
        ...state.more,
        amenities: {
          ...state.more.amenities,
          [id]: value,
        },
      },
    }
  },
  [HOTEL_TYPE_CHANGE](state, { hotelType, value }) {
    return {
      ...state,
      more: {
        ...state.more,
        hotelType: {
          ...state.more.hotelType,
          [hotelType]: value,
        },
      },
    }
  },
  [CODE_CHANGE](state, { fieldName, value }) {
    return {
      ...state,
      code: {
        ...state.code,
        [fieldName]: value,
      },
    }
  },
  [FILTER_APPLY](state, { filterType, doApply }) {
    return {
      ...state,
      [`${filterType}Apply`]: doApply,
    }
  },
  [CHANGE_MULTIPLE](state, { isMultipleBooking }) {
    return {
      ...state,
      isMultipleBooking,
    }
  },
  [FILTER_CLEAR](state, { filterType, doApply }) {
    return {
      ...state,
      [filterType]: initialState[filterType],
      [`${filterType}Apply`]: doApply,
    }
  },
})
